import exclamationMark from "@assets/images/exclamation-mark.svg";
import { Button, Dialog, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

interface InvalidModalProps {
  title: string;
  content: string;
  buttonContent: string;
  open: boolean;
  testId?: string;
  onClose(): void;
}

const useStyle = makeStyles(
  theme => ({
    paper: {
      width: "420px",
      padding: "43px 32px 32px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      ".MuiDialog-paper": {
        background: "none"
      }
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.6rem"
    },
    cloudIcon: {
      width: 56,
      height: 56,
      marginBottom: "2.7rem"
    },
    des: {
      marginBottom: "1.6rem",
      textAlign: "center"
    },
    errorcode: {
      color: theme.palette.grey[500],
      marginBottom: "1.6rem"
    },
    btnSubmit: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      borderRadius: "4px",
      width: "100%",
      padding: "12px",

      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    }
  }),
  { name: "InvalidModal" }
);

const InvalidModal: React.FC<InvalidModalProps> = props => {
  const { open, onClose, title, content, buttonContent, testId } = props;
  const classes = useStyle();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      data-testid={testId ?? "invalidModal"}
    >
      <Paper className={classes.paper}>
        <img src={exclamationMark} alt="" className={classes.cloudIcon} />
        <MyTypography variant="h6" className={classes.caption}>
          {title}
        </MyTypography>
        <MyTypography variant="body2" className={classes.des}>
          {content}
        </MyTypography>
        <Button
          id="closeButton"
          data-testid="closeButton"
          onClick={onClose}
          className={classes.btnSubmit}
        >
          <MyTypography variant="body1">{buttonContent}</MyTypography>
        </Button>
      </Paper>
    </Dialog>
  );
};

export default InvalidModal;
